import { generatePopup } from "../../utility/popup";
import * as actionTypes from "../ActionTypes";
import { apiDelete, apiGet, apiPost, apiPut } from "../axios";

export const getPayment = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_PAYMENT_INIT,
    });

    try {
      const response = await apiGet(
        `payments?page=${payload?.page}&limit=${payload?.limit}&search=${payload?.search}`,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.GET_PAYMENT_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        dispatch({
          type: actionTypes.GET_PAYMENT_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 401) {
        dispatch({
          type: actionTypes.GET_PAYMENT_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const addPayment = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.ADD_PAYMENT_INIT,
    });

    try {
      const response = await apiPost("payments", payload, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.ADD_PAYMENT_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.ADD_PAYMENT_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 401) {
        dispatch({
          type: actionTypes.ADD_PAYMENT_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const DeletePayment = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_PAYMENT_INIT,
    });

    try {
      const response = await apiDelete(`payments/${payload}`, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.DELETE_PAYMENT_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.DELETE_PAYMENT_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.DELETE_PAYMENT_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 401) {
        dispatch({
          type: actionTypes.DELETE_PAYMENT_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};

export const UpdatePayment = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_PAYMENT_INIT,
    });

    try {
      const response = await apiPut(
        `payments/${payload.id}`,
        payload.data,
        token
      );
      if (response.status === 200) {
        dispatch({
          type: actionTypes.UPDATE_PAYMENT_SUCCESS,
          payload: response.data,
        });
        generatePopup("success", response?.data?.message);
        return response.data;
      } else {
        dispatch({
          type: actionTypes.UPDATE_PAYMENT_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 404) {
        dispatch({
          type: actionTypes.UPDATE_PAYMENT_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 403) {
        dispatch({
          type: actionTypes.UPDATE_PAYMENT_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      } else if (error?.status === 400) {
        dispatch({
          type: actionTypes.UPDATE_PAYMENT_FAIL,
          payload: error?.data?.message,
        });
        generatePopup("error", error?.data?.message);
      }
      throw error;
    }
  };
};

export const getPaymentById = (payload, dispatch) => {
  const token = localStorage.getItem("token");
  return async (dispatch) => {
    dispatch({
      type: actionTypes.GET_BYID_PAYMENT_INIT,
    });

    try {
      const response = await apiGet(`payments/${payload}`, token);
      if (response.status === 200) {
        dispatch({
          type: actionTypes.GET_BYID_PAYMENT_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        dispatch({
          type: actionTypes.GET_BYID_PAYMENT_FAIL,
          payload: response?.data?.message,
        });
        return response.data;
      }
    } catch (error) {
      console.log("error", error);
      if (error?.status === 401) {
        dispatch({
          type: actionTypes.GET_BYID_PAYMENT_FAIL,
          payload: error?.data?.message,
        });
        localStorage.clear();
        generatePopup("error", error?.data?.message);
      }
      return error;
    }
  };
};
